export const HAMBURGER_MENU = {
  openDrawer: 'hamburgerMenu/OPEN',
  closeDrawer: 'hamburgerMenu/CLOSE',
} as const;

export const CITY_PICKER_MENU = {
  openDrawer: 'cityPickerMenu/OPEN',
  closeDrawer: 'cityPickerMenu/CLOSE',
} as const;

export const REGIONS_MENU = {
  openDrawer: 'regionsMenu/OPEN',
  closeDrawer: 'regionsMenu/CLOSE',
} as const;

export const CITY_PICKER_HINT = {
  openHint: 'hint/OPEN',
  closeHint: 'hint/CLOSE',
} as const;

export type HamburgerMenuEvents = {
  'hamburgerMenu/OPEN': boolean;
  'hamburgerMenu/CLOSE': boolean;
};

export type CityPickerEvents = {
  'cityPickerMenu/OPEN': boolean;
  'cityPickerMenu/CLOSE': boolean;
  'regionsMenu/OPEN': boolean;
  'regionsMenu/CLOSE': boolean;
  'hint/OPEN': boolean;
  'hint/CLOSE': boolean;
};
